import { IAddPermission, IPermissionListSearch, SetAuthorityInUser } from "../../../../types/permissions/permissionInterface";
import api from "../../../../lib/api";


export const getPermissionListApi = async (data: IPermissionListSearch) => {
  return await api.get(`permission/${data.page}/${data.pageLimit}`, {
    params: {
      search: data.search ?? "",
      sectionId: data.sectionId ?? 0,
    }
  });
};

export const addPermissionApi = async (data: IAddPermission) => {
  return await api.post(`permission/`, data);
};

export const getPermissionDropdownListApi = async (data:any) => {
  return await api.get(`permission/${data.page}/${data.pageLimit}?search=${data?.search ?? ""}`);
}

export const getPermissionByUserIdApi = async (userId: string) => {
  return await api.get(`user/permissions/${userId}`);
}

export const setPermissionsInUserApi = async (data: SetAuthorityInUser) => {
  return await api.put(`user/permissions/${data.userId}`, data.payload);
}